import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import classnames from 'classnames';

import { LogoBlack } from '../../../common/icons/Logos';

import ContactsInfo from '../../../common/footer/ContactsInfo';
import AddressInfo from '../../../common/footer/AddressInfo';

import SubscribeForm from '../../../common/forms/SubscribeForm';

const FooterMobile = props => {
  return (
    <div className={classnames('m-footer', { 'm-footer-gray': props.isGray })}>
      <Link to="/" className="is-flex align-items-center">
        <LogoBlack />
      </Link>
      <ContactsInfo />
      <p className="my-15px">
        <HashLink to="/#start-screen-container-id" className="m-footer-link" smooth>
          Main
        </HashLink>
        <HashLink to="/#info-screen-container-id" className="m-footer-link" smooth>
          About
        </HashLink>
        <Link to="/courses" className="m-footer-link">
          Courses
        </Link>
        <HashLink to="/#faq-screen-container-id" className="m-footer-link" smooth>
          FAQ
        </HashLink>
      </p>

      {props.isGray && <SubscribeForm isMobile />}

      <AddressInfo />
    </div>
  );
};

FooterMobile.propTypes = {
  isGray: PropTypes.bool,
};

export default FooterMobile;
